import { sanitizeEphemeralEnv } from "./sanitizeEphemeralEnv";
import { brandConfiguration } from "@/brands/config";
import { CLASSIFIED_PUBLIC_PATH } from "@/constants";
import { ENVS } from "@/types";
export const getBffurl = ({ env, classifiedId, query, brand, search, previewMode, isCsr = false, }) => {
    var _a, _b;
    if (!classifiedId)
        return null;
    const ephemeralBff = (_a = query === null || query === void 0 ? void 0 : query.bff) !== null && _a !== void 0 ? _a : search === null || search === void 0 ? void 0 : search.get("bff");
    const ephemeralCds = (_b = query === null || query === void 0 ? void 0 : query.cds) !== null && _b !== void 0 ? _b : search === null || search === void 0 ? void 0 : search.get("cds");
    const ephemeralDefaultValueBFF = "main";
    const envBff = sanitizeEphemeralEnv(env, ephemeralBff, {
        defaultValue: ephemeralDefaultValueBFF,
    });
    const envCds = sanitizeEphemeralEnv(env, ephemeralCds, {
        preffix: "?cds=",
    });
    const path = previewMode ? "preview" : "classified";
    const version = previewMode ? "v1" : "v2";
    const hasBffephemeral = envBff !== ephemeralDefaultValueBFF && env !== ENVS.LIVE;
    // Client-side BFF data-fetching using public path
    // @todo: handle preview-mode
    if (isCsr && !hasBffephemeral) {
        return `${brandConfiguration.urls.staging[env]}${CLASSIFIED_PUBLIC_PATH}/${classifiedId}${envCds}`;
    }
    // Server-side BFF data-fetching using private path
    return `https://bff-${envBff}-${brand}-bff.awaited-seagull-${env}.aws.aviv-internal.eu/${version}/${path}/${classifiedId}${envCds}`;
};
